import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { FINANCE, LEASE } from '@makemydeal/dr-platform-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useSelector } from 'react-redux';

/**
 * One gate for every grid component, so a column is never rendered by redesign rules while the middleware prices it by
 * the old ones. **Deal-type scope lives here and nowhere else in this package**, mirrored by offer-redux's
 * `isAspPaymentGridRedesignActive`. Balloon and Cash are held back because they never populate `columnSources`; Flex Buy
 * is excluded outright, and `SellRates` is shared with it - which is why the check belongs here.
 *
 * Toggle read via shared-store, not offer-redux's gate: only that slice updates on `GET_DETAILS_SUCCESS`.
 */
export const useIsAspPaymentGridRedesignActive = (): boolean => {
    const isToggleEnabled = useSelector(featureToggleSelectors.isAspPaymentGridRedesignEnabled);
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const isFlexBuyPayment = useSelector(offerReduxSelectors.isFlexBuyPayment);

    return isToggleEnabled && (offerType === FINANCE || offerType === LEASE) && !isFlexBuyPayment;
};
